/**
 * Created by Angelika on 01.09.2017.
 */
import React, {Component} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from "redux";
import PropTypes from 'prop-types';
import {Link} from 'react-router';
import * as strings from '../constants/strings';
import * as ChannelsActions from '../actions/channels';
import * as VideoActions from '../actions/video';
import * as AppContentActions from '../actions/appContent';
import VideoBlock from './VideoBlock';
import EpgBlock from "./EpgBlock";
import NotFound from '../components/NotFound';

const checkEpgMissing = (epg) => {
    let firstDayEpg = epg.values().next().value;
    return !firstDayEpg.loaded;
};

class PlayerFrame extends Component {

    constructor(props) {
        super(props);
        this.state = {
            error: null,
            mobileEPGShow: false
        }
    }

    componentDidMount() {
        const {activeChannel, channels, params: {channelID}, channelsActions, appContentActions} = this.props;
        appContentActions.showPlayerFrame();
        if (channelID) {
            if (activeChannel && activeChannel.channelID === +channelID) {
                return;
            }
            const channel = channels.find(item => item.channelID === +channelID);
            if (channel) {
                channelsActions.playChannel(channel, true);
            } else {
                this.setState({error: `${strings.CHANNEL_NOT_FOUND}: "${channelID}"`});
            }
        }
    }

    actionStopVideo() {
        const {channelsActions, videoActions} = this.props;
        channelsActions.resetChannelActive();
        videoActions.resetVideo();
    }

    actionReturnVideo() {
        const {videoActions} = this.props;
        videoActions.pause();
    }

    actionClickEPG() {
        this.setState({mobileEPGShow: !this.state.mobileEPGShow});
    }

    render() {
        const {activeChannel, channelLink, epgMissing, videoClasses} = this.props;
        if (this.state.error) {
            return <NotFound addMsg={this.state.error} />;
        } else {
            return (
                <section id="player-frame" className={videoClasses + (epgMissing ? " epg-missing" : "")}>
                    <Link to={'/channels'} onClick={this.actionReturnVideo.bind(this)}>
                        <div className="action back">{strings.STR_RETURN}</div>
                    </Link>
                    <div className="action epg" onClick={this.actionClickEPG.bind(this)}>{strings.STR_EPG}</div>
                    <div className="player-block">
                        <div className="wrapper">
                            {channelLink.isFetching || channelLink.url === null
                                ? <div className="fetching">
                                    <div className="spinner"></div>
                                </div>
                                : <VideoBlock preview={false} stopVideo={this.actionStopVideo.bind(this)}/>
                            }
                        </div>
                    </div>
                    {activeChannel && <EpgBlock mobileEPGShow={this.state.mobileEPGShow} onClose={this.actionClickEPG.bind(this)} />}
                </section>
            )
        }
    }
}

PlayerFrame.propTypes = {
    videoClasses: PropTypes.string.isRequired,
    epgMissing: PropTypes.bool.isRequired,
    channelsActions: PropTypes.object.isRequired
};

const mapStateToProps = state => {
    return {
        activeChannel: state.channels.activeChannel,
        channels: state.channels.items,
        channelLink: state.channelLink,
        videoClasses: state.video.classes,
        epgMissing: checkEpgMissing(state.epg)
    }
};

const mapDispatchToProps = dispatch => {
    return {
        channelsActions: bindActionCreators(ChannelsActions, dispatch),
        videoActions: bindActionCreators(VideoActions, dispatch),
        appContentActions: bindActionCreators(AppContentActions, dispatch)
    }
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(PlayerFrame);


// WEBPACK FOOTER //
// ./src/containers/PlayerFrame.js